import { actionTypes } from './actions';

export const reducer = (action) => ({
  [actionTypes.SET_PUSH_NOTIFICATION_IN_DIALOG_SHOW]: () => ({
    isPushNotificationShown: action.payload.isPushNotificationShown,
  }),
  [actionTypes.SET_INJECTED_HP]: () => ({
    isInjectedHP: action.payload.isInjectedHP,
  }),
  [actionTypes.SET_INJECTED_HP_IN_VIEW]: () => ({
    isInjectedHPInView: action.payload.isInjectedHPInView,
  }),
  [actionTypes.SET_VIDEO_CAROUSEL_STATUS]: () => ({
    videoCarouselStatus: action.payload.videoCarouselStatus,
  }),
  [actionTypes.SET_PLAYERS_ON_PAGE]: (prevState) => ({
    playersOnPage: [...prevState.playersOnPage, ...action.payload.playersOnPage],
  }),
});
